export class SingleEvent<P=any> {
    private Subscribers:{reference:any[],callback:(T)=>void,priority:number}[];

    constructor() {
        this.Subscribers = [];
    }

    public Subscribe(reference:any|any[],callback:(T)=>void,priority=10){
        if(!Array.isArray(reference))
            reference=[reference];

        if(this.GetSubscriberByRef(reference))
            return;

        this.Subscribers.push({reference:reference,callback:callback,priority:priority});
    }

    public Unsubscribe(reference:any|any[]){

        let subscriber=this.GetSubscriberByRef(reference);
        if(subscriber==null)
            return;

        this.Subscribers.splice(this.Subscribers.indexOf(subscriber),1);
    }

    public GetSubscriberByRef(reference:any|any[])
    {
        if(!Array.isArray(reference))
            reference=[reference];
        return this.Subscribers.find(Sub=>Sub.reference.length==reference.length&& Sub.reference.filter(savedRef=>reference.some(ref=>ref==savedRef)).length==Sub.reference.length);
    }

    public Publish(args?:P):any
    {
        let result=null;
        for(let subscriber of this.Subscribers) {
            let aux=subscriber.callback(args);
            if(aux!==undefined)
                result=aux;
        }

        return result;
    }
}